<template>
 <div class="container news mb-5" v-if="feed.length">
    <div class="row">
      <div class="col-10 offset-1 text-center center">
        <h2>News</h2>
      </div>
    </div>
    <div class="row">
      <div v-for="item in feed" class="col-10 offset-1 col-md-6 offset-md-0 col-lg-4 mb-3 text-center center" v-bind:key="item.id">
        <router-link v-if="item.issueNumber === undefined" :to="`/news/${item.id}`">
          <div class="revive-card">
            <div class="label"> {{ new Date(item.publishedAt).toLocaleDateString() }} </div>
            <div v-if="item.image.url" class="card-img-top"
              :style="{ background: `url(${item.image.url})` }"> </div>
            <div class="card-body">
              <h5 class="mb-2">{{ item.title }}</h5>
              <p class="card-text">{{ item.description }}</p>
            </div>
         </div>
        </router-link>
        <a v-else :href="item.pdfFile.url" target="_blank" rel="noopener">
          <div class="revive-card">
            <div class="label"> {{ new Date(item.publishedAt).toLocaleDateString() }} </div>
            <div v-if="item.image.url" class="card-img-top"
              :style="{ background: `url(${item.image.url})` }"> </div>
            <div class="card-body">
              <h5 class="mb-2">Newsletter #{{ item.issueNumber }}</h5>
              <p class="card-text"> Learn all about our latest updates and insights.</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useNewsStore } from '@/stores/news'
import { useNewslettersStore } from '@/stores/newsletters'
import { defineProps, computed } from 'vue'

const props = defineProps(['maxNews'])

const newsStore = useNewsStore();
const newslettersStore = useNewslettersStore();
newsStore.init();
newslettersStore.init();

const feed = computed(() => {
  const merged = [...newsStore.news.value, ...newslettersStore.newsletters.value]
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
  return props.maxNews ? merged.slice(0, props.maxNews) : merged;
});

</script>
<style lang="scss" scoped>
  .news {
    h2 {
      padding-top: 2rem;
    }
  }

  a {
    text-decoration: none;
    height: 100%;
    display: flex;
  }
</style>